import React from 'react';
import { I18n } from 'react-redux-i18n';

import { I18N_BASE } from '../../constants';
import { scoreSeverity } from '../../helpers/bandColor';
import styles from './ScorePill.module.css';

export interface ScorePillProps {
  score: number;
  size?: 'small' | 'medium';
  ariaLabel?: string;
  testId?: string;
}

export function ScorePill({
  score,
  size = 'medium',
  ariaLabel,
  testId,
}: ScorePillProps): React.ReactElement {
  const severity = scoreSeverity(score);
  const className = [
    styles.pill,
    size === 'small' ? styles.pillSmall : '',
    styles[severity],
  ]
    .filter(Boolean)
    .join(' ');
  return (
    <span
      className={className}
      aria-label={
        ariaLabel ?? I18n.t(`${I18N_BASE}.general.scoreAriaLabel`, { score })
      }
      data-testid={testId}
      data-severity={severity}
    >
      {score}
    </span>
  );
}

export default ScorePill;
